import {
  cn
} from "./chunk-PRYE6Q3K.js";

// src/map/pmtiles.ts
import maplibregl from "maplibre-gl";
import { Protocol } from "pmtiles";
var installed = false;
function installPmtilesProtocol(mgl = maplibregl) {
  if (installed) return;
  installed = true;
  const protocol = new Protocol();
  mgl.addProtocol("pmtiles", protocol.tile);
}

// src/map/glyphs.ts
import maplibregl2 from "maplibre-gl";

// src/map/glyph-manifest.ts
var GLYPHS = {
  "JetBrains Mono Bold/0-255": new URL("./fonts/glyphs/jetbrains-mono-bold/0-255.pbf", import.meta.url).href,
  "JetBrains Mono Bold/256-511": new URL("./fonts/glyphs/jetbrains-mono-bold/256-511.pbf", import.meta.url).href,
  "JetBrains Mono Bold/512-767": new URL("./fonts/glyphs/jetbrains-mono-bold/512-767.pbf", import.meta.url).href,
  "JetBrains Mono Bold/768-1023": new URL("./fonts/glyphs/jetbrains-mono-bold/768-1023.pbf", import.meta.url).href,
  "JetBrains Mono Bold/7680-7935": new URL("./fonts/glyphs/jetbrains-mono-bold/7680-7935.pbf", import.meta.url).href,
  "JetBrains Mono Regular/0-255": new URL("./fonts/glyphs/jetbrains-mono-regular/0-255.pbf", import.meta.url).href,
  "JetBrains Mono Regular/256-511": new URL("./fonts/glyphs/jetbrains-mono-regular/256-511.pbf", import.meta.url).href,
  "JetBrains Mono Regular/512-767": new URL("./fonts/glyphs/jetbrains-mono-regular/512-767.pbf", import.meta.url).href,
  "JetBrains Mono Regular/768-1023": new URL("./fonts/glyphs/jetbrains-mono-regular/768-1023.pbf", import.meta.url).href,
  "JetBrains Mono Regular/7680-7935": new URL("./fonts/glyphs/jetbrains-mono-regular/7680-7935.pbf", import.meta.url).href,
  "Noto Sans Bold/0-255": new URL("./fonts/glyphs/noto-sans-bold/0-255.pbf", import.meta.url).href,
  "Noto Sans Bold/256-511": new URL("./fonts/glyphs/noto-sans-bold/256-511.pbf", import.meta.url).href,
  "Noto Sans Bold/3584-3839": new URL("./fonts/glyphs/noto-sans-bold/3584-3839.pbf", import.meta.url).href,
  "Noto Sans Bold/512-767": new URL("./fonts/glyphs/noto-sans-bold/512-767.pbf", import.meta.url).href,
  "Noto Sans Bold/768-1023": new URL("./fonts/glyphs/noto-sans-bold/768-1023.pbf", import.meta.url).href,
  "Noto Sans Bold/7680-7935": new URL("./fonts/glyphs/noto-sans-bold/7680-7935.pbf", import.meta.url).href,
  "Noto Sans Regular/0-255": new URL("./fonts/glyphs/noto-sans-regular/0-255.pbf", import.meta.url).href,
  "Noto Sans Regular/256-511": new URL("./fonts/glyphs/noto-sans-regular/256-511.pbf", import.meta.url).href,
  "Noto Sans Regular/3584-3839": new URL("./fonts/glyphs/noto-sans-regular/3584-3839.pbf", import.meta.url).href,
  "Noto Sans Regular/512-767": new URL("./fonts/glyphs/noto-sans-regular/512-767.pbf", import.meta.url).href,
  "Noto Sans Regular/768-1023": new URL("./fonts/glyphs/noto-sans-regular/768-1023.pbf", import.meta.url).href,
  "Noto Sans Regular/7680-7935": new URL("./fonts/glyphs/noto-sans-regular/7680-7935.pbf", import.meta.url).href
};

// src/map/glyphs.ts
var SCHEME = "pn-glyphs";
var installed2 = false;
function installGlyphProtocol(mgl = maplibregl2) {
  if (installed2) return;
  installed2 = true;
  mgl.addProtocol(SCHEME, async (params) => {
    const key = decodeURIComponent(params.url.slice(`${SCHEME}://`.length)).replace(/\.pbf$/, "");
    const asset = GLYPHS[key];
    if (!asset) return { data: new ArrayBuffer(0) };
    const res = await fetch(asset);
    return { data: await res.arrayBuffer() };
  });
}
function glyphProtocolUrl(url) {
  const m = url.match(/([^/]+)\/(\d+-\d+)\.pbf$/);
  if (!m) return null;
  const range = m[2];
  for (const part of decodeURIComponent(m[1]).split(",")) {
    const stack = part.trim();
    if (`${stack}/${range}` in GLYPHS) return `${SCHEME}://${encodeURIComponent(stack)}/${range}.pbf`;
  }
  return null;
}

// src/map/registry.ts
import maplibregl3 from "maplibre-gl";
var registries = /* @__PURE__ */ new WeakMap();
function registerOverlay(map, provider) {
  let set = registries.get(map);
  if (!set) registries.set(map, set = /* @__PURE__ */ new Set());
  set.add(provider);
  return () => {
    registries.get(map)?.delete(provider);
  };
}
function recenterMap(map, opts = { padding: 60, duration: 500 }) {
  const union = new maplibregl3.LngLatBounds();
  let any = false;
  for (const provider of registries.get(map) ?? []) {
    const b = provider.getBounds();
    if (b && !b.isEmpty()) {
      union.extend(b);
      any = true;
    }
  }
  if (any) map.fitBounds(union, opts);
  return any;
}

// src/map/maplibre-core.ts
function toLngLat(c) {
  return [c[1], c[0]];
}
function toLngLatArr(cs) {
  return cs.map(toLngLat);
}
function awaitIdleOrTimeout(map, maxMs = 5e3) {
  return new Promise((resolve) => {
    let settled = false;
    const settle = (ok) => {
      if (!settled) {
        settled = true;
        resolve(ok);
      }
    };
    const t = setTimeout(() => settle(false), maxMs);
    map.once("idle", () => {
      clearTimeout(t);
      settle(true);
    });
  });
}
async function withHighDprMap(map, fn) {
  const originalRatio = map.getPixelRatio();
  try {
    map.setPixelRatio(4);
    await awaitIdleOrTimeout(map);
    return await fn(4);
  } finally {
    try {
      map.setPixelRatio(originalRatio);
      await awaitIdleOrTimeout(map);
    } catch {
    }
  }
}
function captureFilter(el) {
  if (el.classList?.contains("capture-hide")) return false;
  if (el.classList?.contains("maplibregl-control-container")) return false;
  return true;
}
function overlayFilter(el) {
  if (!captureFilter(el)) return false;
  if (el instanceof HTMLCanvasElement && el.classList?.contains("maplibregl-canvas")) return false;
  return true;
}
function captureFilename(prefix, kind) {
  const stamp = (/* @__PURE__ */ new Date()).toISOString().slice(0, 16).replace(/[-:T]/g, "").slice(0, 12);
  return `${prefix || "map"}${kind ? `-${kind}` : ""}-${stamp}.png`;
}
async function compositeCapture(map, wrapperEl) {
  const htmlToImage = await import("html-to-image");
  const gl = map.getCanvas();
  const W = gl.width;
  const H = gl.height;
  const cssW = gl.clientWidth || W;
  const ratio = W / cssW;
  const out = document.createElement("canvas");
  out.width = W;
  out.height = H;
  const ctx = out.getContext("2d");
  if (!ctx) throw new Error("2D canvas context unavailable for capture");
  ctx.drawImage(gl, 0, 0);
  const mapEl = map.getContainer();
  const prevBg = mapEl.style.background;
  mapEl.style.background = "transparent";
  try {
    const overlay = await htmlToImage.toCanvas(wrapperEl, { pixelRatio: ratio, cacheBust: true, filter: overlayFilter });
    ctx.drawImage(overlay, 0, 0, W, H);
  } finally {
    mapEl.style.background = prevBg;
  }
  return out;
}
function canvasToBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((b) => b ? resolve(b) : reject(new Error("capture produced an empty blob")), "image/png");
  });
}
async function exportPng(map, wrapperEl, kind = "", prefix = "map") {
  await withHighDprMap(map, async () => {
    const canvas = await compositeCapture(map, wrapperEl);
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = captureFilename(prefix, kind);
    a.click();
  });
}
async function copyPngToClipboard(map, wrapperEl, kind = "") {
  void kind;
  if (!window.isSecureContext) throw new Error("Image copy requires HTTPS (current origin is insecure).");
  if (typeof window.ClipboardItem === "undefined" || !navigator.clipboard?.write) {
    throw new Error("Browser does not support image clipboard write.");
  }
  await withHighDprMap(map, async () => {
    const blobPromise = compositeCapture(map, wrapperEl).then(canvasToBlob);
    await navigator.clipboard.write([new ClipboardItem({ "image/png": blobPromise })]);
  });
}

// src/map/core.ts
import maplibregl4 from "maplibre-gl";
var DEFAULT_STYLE_URL = "https://tiles.openfreemap.org/styles/positron";
var DEFAULT_DARK_STYLE_URL = "https://tiles.openfreemap.org/styles/dark";
function createMapCore(el, opts = {}) {
  installPmtilesProtocol();
  installGlyphProtocol();
  const themeManaged = !opts.styleUrl || !!opts.darkStyleUrl;
  const styleFor = (dark) => !themeManaged ? opts.styleUrl : dark ? opts.darkStyleUrl ?? DEFAULT_DARK_STYLE_URL : opts.styleUrl ?? DEFAULT_STYLE_URL;
  let currentStyle = styleFor(!!opts.dark);
  const map = new maplibregl4.Map({
    container: el,
    style: currentStyle,
    ...opts.center ? { center: opts.center } : {},
    ...opts.zoom != null ? { zoom: opts.zoom } : {},
    transformRequest: (url) => {
      const glyph = glyphProtocolUrl(url);
      if (glyph) return { url: glyph };
      return typeof location !== "undefined" && url.startsWith("/") && !url.startsWith("//") ? { url: location.origin + url } : void 0;
    },
    attributionControl: false,
    // Flat 2D — no bearing rotation or pitch.
    dragRotate: false,
    pitchWithRotate: false,
    touchPitch: false,
    maxPitch: 0,
    // antialias: crisp route lines; preserveDrawingBuffer: lets the 4× PNG export read the canvas.
    canvasContextAttributes: { antialias: true, preserveDrawingBuffer: true }
  });
  map.touchZoomRotate.disableRotation();
  map.addControl(new maplibregl4.NavigationControl({ showCompass: false }), "top-left");
  if (opts.bounds) map.fitBounds(opts.bounds, { padding: 60, duration: 0 });
  let veil = null;
  if (opts.loading !== false) {
    if (getComputedStyle(el).position === "static") el.style.position = "relative";
    veil = document.createElement("div");
    veil.className = "pn-map-loading is-visible";
    const spinner = document.createElement("div");
    spinner.className = "pn-spinner";
    const titleEl = document.createElement("div");
    titleEl.className = "pn-map-loading-title";
    titleEl.textContent = opts.loadingTitle ?? "Loading map\u2026";
    veil.appendChild(spinner);
    veil.appendChild(titleEl);
    el.appendChild(veil);
  }
  let veilLifted = false;
  const liftVeil = () => {
    if (veilLifted || !veil) return;
    veilLifted = true;
    const v = veil;
    v.classList.remove("is-visible");
    const remove = () => v.remove();
    v.addEventListener("transitionend", remove, { once: true });
    setTimeout(remove, 500);
  };
  let finished = false;
  const ready = () => {
    if (finished) return;
    finished = true;
    const moved = opts.fitToData !== false ? recenterMap(map, { padding: 60, duration: 0 }) : false;
    if (moved) {
      map.once("idle", liftVeil);
      setTimeout(liftVeil, 1200);
    } else {
      liftVeil();
    }
  };
  if (!opts.deferReady) map.once("idle", ready);
  let destroyed = false;
  let captureRoot = el;
  return {
    map,
    recenter: (fitOpts) => destroyed ? false : recenterMap(map, fitOpts),
    setCaptureRoot: (root) => {
      captureRoot = root ?? el;
    },
    ready: () => {
      if (!destroyed) ready();
    },
    setBasemap: (dark) => {
      if (destroyed || !themeManaged) return;
      const next = styleFor(dark);
      if (next === currentStyle) return;
      currentStyle = next;
      map.setStyle(next);
    },
    exportPng: (kind = "") => destroyed ? Promise.resolve() : exportPng(map, captureRoot, kind, opts.exportPrefix ?? "map"),
    copyToClipboard: (kind = "") => destroyed ? Promise.resolve() : copyPngToClipboard(map, captureRoot, kind),
    destroy: () => {
      if (destroyed) return;
      destroyed = true;
      map.off("idle", ready);
      veil?.remove();
      map.remove();
    }
  };
}

// src/map/map-controls.tsx
import * as React from "react";
import { createPortal } from "react-dom";
import { Check, Copy, Download, Loader2, Scan, X } from "lucide-react";
import { jsx, jsxs } from "react/jsx-runtime";
function clipboardAvailable() {
  return typeof window !== "undefined" && window.isSecureContext && typeof window.ClipboardItem !== "undefined" && typeof navigator !== "undefined" && !!navigator.clipboard?.write;
}
function MapControls({ map, config, onReframe, onCopy, onExport }) {
  const [target, setTarget] = React.useState(null);
  React.useEffect(() => {
    setTarget(map.getContainer().querySelector(".maplibregl-ctrl-top-left"));
  }, [map]);
  const canCopy = React.useMemo(clipboardAvailable, []);
  if (config === false || !target) return null;
  const show = {
    reframe: config?.reframe !== false,
    copyImage: config?.copyImage !== false,
    exportImage: config?.exportImage !== false
  };
  if (!show.reframe && !show.copyImage && !show.exportImage) return null;
  return createPortal(
    /* @__PURE__ */ jsxs("div", { className: "maplibregl-ctrl maplibregl-ctrl-group pn-map-ctrl", children: [
      show.reframe ? /* @__PURE__ */ jsx("button", { type: "button", "aria-label": "Reframe", title: "Reframe to fit", onClick: onReframe, children: /* @__PURE__ */ jsx(Scan, { "aria-hidden": true }) }) : null,
      show.copyImage ? /* @__PURE__ */ jsx(
        AsyncButton,
        {
          Icon: Copy,
          label: "Copy PNG",
          title: canCopy ? "Copy 4\xD7 PNG to clipboard" : "Image copy requires a secure (HTTPS) context",
          disabled: !canCopy,
          action: onCopy
        }
      ) : null,
      show.exportImage ? /* @__PURE__ */ jsx(AsyncButton, { Icon: Download, label: "Export PNG", title: "Download 4\xD7 PNG", action: onExport }) : null
    ] }),
    target
  );
}
function AsyncButton({
  Icon,
  label,
  title,
  disabled,
  action
}) {
  const [state, setState] = React.useState("idle");
  const timer = React.useRef(null);
  React.useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    []
  );
  const run = () => {
    if (disabled || state === "busy") return;
    setState("busy");
    void action().then(
      () => setState("done"),
      () => setState("error")
    ).finally(() => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setState("idle"), 1400);
    });
  };
  const Glyph = state === "busy" ? Loader2 : state === "done" ? Check : state === "error" ? X : Icon;
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      "aria-label": label,
      title,
      disabled: disabled || state === "busy",
      "data-state": state,
      onClick: run,
      children: /* @__PURE__ */ jsx(Glyph, { "aria-hidden": true, className: state === "busy" ? "animate-spin" : void 0 })
    }
  );
}

// src/map/map.tsx
import * as React2 from "react";
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function Map({ className, style, ariaLabel, onReady, controls, onReframe, ...opts }) {
  const elRef = React2.useRef(null);
  const handleRef = React2.useRef(null);
  const [handle, setHandle] = React2.useState(null);
  const onReadyRef = React2.useRef(onReady);
  onReadyRef.current = onReady;
  const onReframeRef = React2.useRef(onReframe);
  onReframeRef.current = onReframe;
  React2.useEffect(() => {
    const el = elRef.current;
    if (!el) return;
    const h = createMapCore(el, opts);
    handleRef.current = h;
    onReadyRef.current?.(h);
    setHandle(h);
    return () => {
      setHandle(null);
      h.destroy();
      handleRef.current = null;
    };
  }, []);
  React2.useEffect(() => {
    handleRef.current?.setBasemap(!!opts.dark);
  }, [opts.dark]);
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx2("div", { ref: elRef, role: "img", "aria-label": ariaLabel ?? "Map", className: cn("pn-map", className), style: { width: "100%", height: "100%", ...style } }),
    handle ? /* @__PURE__ */ jsx2(
      MapControls,
      {
        map: handle.map,
        config: controls,
        onReframe: () => {
          const override = onReframeRef.current;
          if (override) override();
          else handle.recenter();
        },
        onCopy: () => handle.copyToClipboard(),
        onExport: () => handle.exportPng()
      }
    ) : null
  ] });
}

export {
  installPmtilesProtocol,
  installGlyphProtocol,
  glyphProtocolUrl,
  registerOverlay,
  recenterMap,
  toLngLat,
  toLngLatArr,
  exportPng,
  copyPngToClipboard,
  DEFAULT_STYLE_URL,
  DEFAULT_DARK_STYLE_URL,
  createMapCore,
  MapControls,
  Map
};
//# sourceMappingURL=chunk-HBOVEW7J.js.map